var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.493,
    height: 15.432,
    viewBox: "0 0 15.493 15.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connection",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11239",
    "data-name": "Path 11239",
    d: "M332.179,426a1.212,1.212,0,0,0-1.122.756H330v.908h1.057A1.21,1.21,0,1,0,332.179,426Z",
    transform: "translate(-320.014 -412.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240",
    "data-name": "Path 11240",
    d: "M334.3,311.908a1.2,1.2,0,0,0-.552.134l-1.124-.937a.454.454,0,0,0-.291-.105H330v.908h2.166l.985.821a1.21,1.21,0,1,0,1.146-.821Z",
    transform: "translate(-320.014 -300.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241",
    "data-name": "Path 11241",
    d: "M334.3,216a1.212,1.212,0,0,0-1.122.756H330v.908h3.175A1.21,1.21,0,1,0,334.3,216Z",
    transform: "translate(-320.014 -208.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11242",
    "data-name": "Path 11242",
    d: "M332.621,94.223l1.124-.937a1.211,1.211,0,1,0-.593-.687l-.985.821H330v.908h2.33A.454.454,0,0,0,332.621,94.223Z",
    transform: "translate(-320.014 -87.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11243",
    "data-name": "Path 11243",
    d: "M332.179,8.421a1.21,1.21,0,1,0-1.122-1.664H330v.908h1.057A1.212,1.212,0,0,0,332.179,8.421Z",
    transform: "translate(-320.014 -4.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11244",
    "data-name": "Path 11244",
    d: "M150,154.177a3.177,3.177,0,0,0,4.539,2.87v-5.74a3.177,3.177,0,0,0-4.539,2.87Z",
    transform: "translate(-145.461 -145.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11245",
    "data-name": "Path 11245",
    d: "M8.624,1H6.808a.454.454,0,0,0-.454.454v.591a6.81,6.81,0,0,0-2.393.991l-.418-.418a.454.454,0,0,0-.642,0L1.618,3.9a.454.454,0,0,0,0,.642l.418.418a6.81,6.81,0,0,0-.991,2.393H.454A.454.454,0,0,0,0,7.808V9.624a.454.454,0,0,0,.454.454h.591a6.811,6.811,0,0,0,.991,2.393l-.418.418a.454.454,0,0,0,0,.642L2.9,14.814a.454.454,0,0,0,.642,0l.418-.418a6.811,6.811,0,0,0,2.393.991v.591a.454.454,0,0,0,.454.454H8.624a.454.454,0,0,0,.454-.454V12.567a4.085,4.085,0,1,1,0-7.7V1.454A.454.454,0,0,0,8.624,1Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.dc8ce6f470e6212514b52e1cbb64a02a.svg";
export { ForwardRef as ReactComponent };